import { getSearchStore } from '../store/Store';

/**
 * Returns the currently active results tab
 */
export const getActiveResultsTab = () => getSearchStore().activeResultsTab;
